import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ShieldCheck, Upload, Trash2 } from "lucide-react";
import BackupTab from "@/components/backup/BackupTab";
import RestoreTab from "@/components/backup/RestoreTab";
import WipeTab from "@/components/backup/WipeTab";

export default function BackupRestorePage() {
  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-display text-xl font-semibold arch-underline">Backup &amp; Restore</h1>
        <p className="text-sm text-muted-foreground">Encrypted date-range backups, preview-then-approve restore, and controlled data clearing</p>
      </div>
      <Tabs defaultValue="backup" className="space-y-4">
        <TabsList className="h-10" data-testid="backup-tabs">
          <TabsTrigger value="backup" data-testid="tab-backup"><ShieldCheck className="h-3.5 w-3.5 mr-1.5" />Backup</TabsTrigger>
          <TabsTrigger value="restore" data-testid="tab-restore"><Upload className="h-3.5 w-3.5 mr-1.5" />Restore</TabsTrigger>
          <TabsTrigger value="wipe" data-testid="tab-wipe"><Trash2 className="h-3.5 w-3.5 mr-1.5" />Clear data</TabsTrigger>
        </TabsList>
        <TabsContent value="backup"><BackupTab /></TabsContent>
        <TabsContent value="restore"><RestoreTab /></TabsContent>
        <TabsContent value="wipe"><WipeTab /></TabsContent>
      </Tabs>
    </div>
  );
}
